import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ShieldCheck, LogIn } from "lucide-react";
import { toast } from "sonner";
import BrandLogo from "@/components/BrandLogo";

export default function LoginPage() {
  const { user, loading, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [err, setErr] = useState("");

  if (loading) return null;
  if (user && user !== false) return <Navigate to="/dashboard" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true); setErr("");
    const res = await login(email, password);
    setSubmitting(false);
    if (res.ok) { toast.success("Login berhasil. Selamat datang!"); nav("/dashboard"); }
    else { setErr(res.error); toast.error(res.error); }
  };

  return (
    <div className="min-h-screen login-pattern flex items-center justify-center p-4">
      <div className="w-full max-w-5xl grid lg:grid-cols-2 rounded-2xl overflow-hidden shadow-2xl bg-white">
        <div className="hidden lg:flex flex-col justify-between p-10 fodm-sidebar-gradient text-white">
          <div>
            <div className="flex flex-col items-start gap-4">
              <BrandLogo size={160} className="drop-shadow-2xl" />
              <div>
                <div className="font-bold text-lg tracking-tight">E-System JKTOFQG</div>
                <div className="text-xs text-white/70">Flight Operation Group</div>
              </div>
            </div>
            <h1 className="mt-10 text-4xl font-bold leading-tight" style={{fontFamily:"Outfit"}}>
              Electronic System<br/><span className="text-[#FFC72C]">Flight Operation Group</span>
            </h1>
          </div>
          <div className="flex items-center gap-3 text-sm text-white/70">
            <ShieldCheck className="w-5 h-5 text-[#FFC72C]" />
            Akses terenkripsi &amp; terkontrol per peran
          </div>
        </div>
        <div className="p-8 lg:p-12 flex flex-col justify-center">
          <div className="mb-8 flex items-center gap-3 lg:hidden">
            <BrandLogo size={64} />
            <div>
              <div className="font-bold text-slate-900">E-System JKTOFQG</div>
              <div className="text-[11px] text-slate-500">Flight Operation Group</div>
            </div>
          </div>
          <div className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900" style={{fontFamily:"Outfit"}}>Masuk ke Portal</h2>
            <p className="text-sm text-slate-500 mt-1">Gunakan kredensial internal Anda</p>
          </div>
          <form onSubmit={submit} className="space-y-4" data-testid="login-form">
            <div className="space-y-1.5">
              <Label htmlFor="email" className="text-xs font-semibold text-slate-700">EMAIL</Label>
              <Input id="email" type="email" value={email} onChange={(e)=>setEmail(e.target.value)} required autoComplete="email" data-testid="login-email" />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="password" className="text-xs font-semibold text-slate-700">KATA SANDI</Label>
              <Input id="password" type="password" value={password} onChange={(e)=>setPassword(e.target.value)} required autoComplete="current-password" data-testid="login-password" />
            </div>
            {err && <div className="text-xs text-red-600 bg-red-50 p-2 rounded" data-testid="login-error">{err}</div>}
            <Button type="submit" disabled={submitting} className="w-full bg-[#00A651] hover:bg-[#008741] h-11 rounded-lg font-semibold" data-testid="login-submit">
              <LogIn className="w-4 h-4 mr-2" /> {submitting ? "Memproses..." : "Masuk"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
